import { render, staticRenderFns } from "./addressList.vue?vue&type=template&id=4287ad48&scoped=true"
import script from "./addressList.vue?vue&type=script&lang=js"
export * from "./addressList.vue?vue&type=script&lang=js"
import style0 from "./addressList.vue?vue&type=style&index=0&id=4287ad48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287ad48",
  null
  
)

export default component.exports